/**
 * Created by casteloyee on 2017/7/18.
 */
import React from 'react';
import { Modal, Row, Col, Input, DatePicker, message, Radio } from 'antd';
import API_URL from '../../common/url';
import ExportUtil from '../../common/ExportUtil';
import moment from "moment";
import AjaxRequest from '../../common/AjaxRequest';

const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;
const { MonthPicker } = DatePicker;

class AddComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            confirmLoading: false,
            comment: '',
            investigationSiteWeekSummaryId: '',
        };
    };

   
    show = (investigationSiteWeekSummaryId, comment) => {
        this.setState({
            visible: true,
            investigationSiteWeekSummaryId,
            comment,
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        });
    };


    onChangeSiteCode = e => {
        this.setState({
            siteCode: e.target.value,
        });
    };

    handleSubmit = () => {
        const {investigationSiteWeekSummaryId, comment} = this.state;
        const options = {
            url: `${API_URL.summary.updateComment}`,
            data: {
                investigationSiteWeekSummaryId,
                comment,
            },
            dataType: 'json',
            doneResult: ( data => {
                    this.setState({
                        visible: false,
                    });
                    this.props.reload();
                }
            ),
        };
        AjaxRequest.sendRequest(options);
    };

    onTextAreaChange = e => {
        const value = e.target.value;
        this.setState({ comment : value });
    }

    render() {
        const {visible, confirmLoading, comment} = this.state;
        return (
            <Modal
                title="填写备注"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <Row>
                    <Col span={5}>备注：</Col>
                    <Col span={18}>
                        <TextArea value={comment} rows={4} onChange={this.onTextAreaChange} />
                    </Col>
                </Row>
            </Modal>
        );
    }
}

class ExportFixedLine extends React.Component {
    state = {
        visible: false,
        confirmLoading: false,
        date: moment(),
    }
    
    show = investigationId => {
        this.setState({
            flag: "",
            visible: true,
            investigationId,
        });
    }

    cancel = () => {
        this.setState({
            visible: false,
            date: moment(),
        });
    }

    query = () => {
        let { date, investigationId, flag } = this.state;
        const { curRole, investigationSiteName } = sessionStorage;
        const isBO = curRole == 'BO';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isSite = investigationSiteName != '';
        if (!investigationId && (isBO || isVP || isFIN) && !isSite) {
            investigationId = flag;
        }
        if (!investigationId && (isBO || isVP || isFIN) && !isSite) {
           if((flag=="")&&(flag!==0)){
            message.error("请选择固化数据导出方式");
            return;
           }
        }
        this.setState({ confirmLoading: true });
        const options = {
            url: `${API_URL.investigation.checkDownloadUserFte}`,
            data: {
                investigationId,
                date: date.format('YYYY-MM')
            },
            dataType: 'json',
            doneResult: ( data => {
                if (!data.error) {
                    this.submit({
                        investigationId,
                        date: date.format('YYYY-MM')
                    });
                } else {
                    message.error(data.error);
                }
                this.setState({ confirmLoading: false });
            }),
            errorResult: ( data => {
                this.setState({ confirmLoading: false });
            }),
        };
        AjaxRequest.sendRequest(options);
    }

    submit = params => {
        const url = API_URL.investigation.downloadUserFte;
        ExportUtil.export(params, null, url);
        this.setState({ visible: false });
    };

    disabledDate = current => {
        return current && current.valueOf() > moment().valueOf();
    }

    onChange = (date, dateString) => {
        if (date == null) {
            date = moment();
        }
        this.setState({ date });
    }

    onRadioChange = (e) => {
        this.setState({ flag: e.target.value });
    }

    render () {
        const { visible, confirmLoading, date, investigationId, flag } = this.state;
        const { curRole, investigationSiteName } = sessionStorage;
        const isBO = curRole == 'BO';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isSite = investigationSiteName != '';
        const radioStyle = {
            display: 'block',
            paddingLeft: 10,
            height: 30,
            lineHeight: '30px',
        };
        return (
            <Modal
                title="导出固化数据"
                visible={visible}
                onOk={this.query}
                onCancel={this.cancel}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="filter-bar">
                    <div className="filter-bar-investigation">                    
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">请先选择固化月份</label>
                            <MonthPicker
                                disabledDate={this.disabledDate}
                                onChange={this.onChange}
                                placeholder="选择月份"
                                style={{width: 160}}
                                allowClear={true}
                                value={date}
                            />
                        </div>
                        {
                            !investigationId && (isBO || isVP || isFIN) && !isSite &&
                            <div className="form-item">
                                <label className="ui-label">固化数据导出方式:</label>
                                <RadioGroup
                                    value={flag}
                                    style={{marginLeft: 2, lineHeight: '28px',display:"grid"}}
                                    onChange={this.onRadioChange}
                                >
                                    <Radio value={-2} style={radioStyle}>全部 (财务版)</Radio>
                                    <Radio value={0} style={radioStyle}>全部 (核对版)</Radio>
                                    <Radio value={-3} style={radioStyle}>排除暂停&终止 (财务版)</Radio>
                                    <Radio value={-1} style={radioStyle}>排除暂停&终止 (核对版)</Radio>
                                </RadioGroup>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export { AddComment, ExportFixedLine };



// WEBPACK FOOTER //
// ./src/components/sumTotal/AddComment.js